/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ConsigneeDeliveryNoteOrganicCertificationNumberControlsRequest } from '../../models/consignee-delivery-note-organic-certification-number-controls-request';
import { KeyType } from '../../models/key-type';

export interface PutConsigneeOrganicCertificationNumberControlsV3$Params {
  organizationSiteKey: KeyType;
  deliveryNoteKey: KeyType;
      body: ConsigneeDeliveryNoteOrganicCertificationNumberControlsRequest
}

export function putConsigneeOrganicCertificationNumberControlsV3(http: HttpClient, rootUrl: string, params: PutConsigneeOrganicCertificationNumberControlsV3$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, putConsigneeOrganicCertificationNumberControlsV3.PATH, 'put');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
    rb.path('deliveryNoteKey', params.deliveryNoteKey, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

putConsigneeOrganicCertificationNumberControlsV3.PATH = '/organization-sites/{organizationSiteKey}/consignee/delivery-notes/{deliveryNoteKey}/controls/organic-certification-number';
